import styles from "./BackgroundModel.module.css";

const Background = () => {
    return (
        <article
            className={styles.article}
            style={{ backgroundImage: `url(https://farmeasy.co.in/API/Images/farmeasy.jpg)` }}
        >
            <div style={{ backgroundColor: 'rgba(41, 41, 41, 0.7)' }}>
                {/* <div class="title" style={{ marginTop: 50 }}>
                    <span>
                        <span class="summer">FarmEasy</span>
                    </span>
                </div> */}
                <div class="title" style={{ marginTop: 50 }}>
                    <span style={{ textShadow: 'initial', color: 'white' }}>
                        Natural & Fresh Vegetables
                    </span>
                </div>
                <div class="description">
                    <h4 style={{ color: 'whitesmoke' }}>
                        Freshness Delivered.
                    </h4>
                    <h4 style={{ color: 'whitesmoke' }}>
                        Quality Assured.
                    </h4>
                </div>
                {/* <button style={{ marginBottom: 50 }} onClick={() => window.open("https://play.google.com/store/apps/details?id=com.ashinfo.farmeasy")} class="order-now">
                    
                </button> */}
                <div style={{  }}>

                </div>
                <img src="https://farmeasy.co.in/API/Images/googleplaybtn.png" target="_blank" onClick={() => window.open("https://play.google.com/store/apps/details?id=com.farmeasynaturalfresh.farmeasy")} style={{ width: 260, height: 100, marginLeft: 30,
                    marginBottom: 30
                 }}
                        alt="Button Image"></img>
                <img src="https://farmeasy.co.in/API/Images/appstorebtn.png" target="_blank" onClick={() => window.open("https://apps.apple.com/in/app/farmeasy-natural-and-fresh/id6742101860")} style={{ width: 230, height: 65, marginLeft: 45,
                    marginBottom: 30
                 }}
                        alt="Button Image"></img>
            </div>
        </article>
    );
};

export default Background;